import * as yup from 'yup'
import { getRequiredSchema } from 'src/deps'

const schema = () => {
  const schemaData = {}
  Object.assign(
    schemaData,
    getRequiredSchema({
      inputName: 'changeAccountTypeName',
    }),
    getRequiredSchema({
      inputName: 'sponsorAffiliateName',
    })
  )
  return yup.object(schemaData)
}

export { schema }
